<p-splitButton
  #splitButton
  *ngIf="model?.length > 0"
  [model]="model"
  [label]="label"
  [icon]="icon"
  [disabled]="disabled"
  appendTo="body"
  (onClick)="onClick($event)">
</p-splitButton>